import { Feature } from './Feature';

export type { TypeFeatureProps } from './types';
export default Feature;
